// import axios from 'axios'
import Vue from "vue";
import Vuex from "vuex";
import { baseApiUrl, printToast } from "./global";
import { VueEasyJwt } from "vue-easy-jwt";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userLogado: false,
    token: null,
    user: null,
    userName: null,
    loaderAtivo: false,
    idenPessoa: null,
    urlPDF: null,
    dadosPDF: null,
    exercicio: null,
    cicloPessoa: null,
    dadosPessoa: null,
    ufAll: null,
    paisAll: null,
    orgaoDocumentos: null,
    areasConhecimento: null,
    userValidacao: null,
    etapasCliclo: null,
    formacaoContinuada: null,
    areaformacoes: null,
    servSelecionado: null,
    cicloSelecionado: null,
    questionarioSelecionado: { descQuestionario: null },
    perguntasQuestionario: [],
    versaoApi: "1.0.0",
    tokenrecaptcha: null,
    counterLoader: 0,
    isRefreshMenu: false,
  },
  getters: {
    getcounterLoader(state) {
      return state.counterLoader;
    },
    isUserLogado(state) {
      // Retorna o estado
      return state.userLogado;
    },
    isloader(state) {
      return state.loaderAtivo || state.counterLoader > 0;
    },
    getUser(state) {
      let dadosStorageSeplagJson = decodeURI(atob(state.user));
      return state.user ? JSON.parse(dadosStorageSeplagJson) : null;
    },
    getToken(state) {
      return state.token ? JSON.parse(atob(state.token)) : null;
    },
    getIdenPessoa(state) {
      return state.idenPessoa ? atob(state.idenPessoa) : "Valor default";
    },
    getUrlPDF(state) {
      return state.urlPDF ? atob(state.urlPDF) : null;
    },
    getDadosPDF(state) {
      return state.dadosPDF ? JSON.parse(atob(state.dadosPDF)) : null;
    },
    getExercicio(state) {
      return state.exercicio;
    },
    getDadosPessoa(state) {
      return state.dadosPessoa ? JSON.parse(state.dadosPessoa) : null;
    },
    getCicloPessoa(state) {
      return state.cicloPessoa ? JSON.parse(atob(state.cicloPessoa)) : null;
    },
    getEtapasCiclo(state) {
      return state.etapasCliclo ? JSON.parse(state.etapasCliclo) : null;
    },
    getUf(state) {
      return state.ufAll;
    },
    getPais(state) {
      return state.paisAll;
    },
    getOrgaoDocumentos(state) {
      return state.orgaoDocumentos;
    },
    getAreasConhecimento(state) {
      return state.areasConhecimento;
    },
    getUserValidacao(state) {
      return state.userValidacao;
    },
    getFormacaoContinuadas(state) {
      return state.formacaoContinuada;
    },
    getAreaFormacoes(state) {
      return state.areaformacoes;
    },
    getServSelecionado(state) {
      return state.servSelecionado;
    },
    getVersaoApi(state) {
      return state.versaoApi;
    },
    getCicloSelecionado(state) {
      return state.cicloSelecionado;
    },
    getQuestionarioSelecionado(state) {
      return state.questionarioSelecionado;
    },
    getPerguntasQuestionario(state) {
      return state.perguntasQuestionario;
    },
    getTokenrecaptcha(state) {
      return state.tokenrecaptcha;
    },
    getIsRefreshMenu(state) {
      return state.isRefreshMenu;
    },
  },
  mutations: {
    setUser(state, user) {
      state.userName = user ? user.contaAcesso.nomeApresentacao : null;
      let dadosStorageSeplagJson = encodeURI(JSON.stringify(user));
      state.user = user ? btoa(dadosStorageSeplagJson) : null;
    },
    setToken(state, token) {
      state.token = token ? btoa(token) : null;
    },
    setUserLogado(state, isUserLogado) {
      state.userLogado = isUserLogado;
    },
    setLoader(state, loaderStatus) {
      state.loaderAtivo = loaderStatus;
    },
    setIdenPessoa(state, idenPessoa) {
      state.idenPessoa = btoa(idenPessoa);
    },
    setUrlPDF(state, urlPDF) {
      state.urlPDF = urlPDF ? btoa(urlPDF) : null;
    },
    setDadosPDF(state, dadosPDF) {
      state.dadosPDF = dadosPDF ? btoa(dadosPDF) : null;
    },
    setExercicio(state, exercicio) {
      state.exercicio = exercicio;
    },
    setCicloPessoa(state, cicloPessoa) {
      state.cicloPessoa = cicloPessoa ? btoa(cicloPessoa) : null;
    },
    setEtapasCiclo(state, etapasCliclo) {
      state.etapasCliclo = etapasCliclo;
    },
    setDadosPessoa(state, dadosPessoa) {
      state.dadosPessoa = dadosPessoa ? dadosPessoa : null;
    },
    setUf(state, uf) {
      state.ufAll = uf;
    },
    setPais(state, pais) {
      state.paisAll = pais;
    },
    setOrgaoDocumentos(state, orgaoDocumentos) {
      state.orgaoDocumentos = orgaoDocumentos;
    },
    setAreasConhecimento(state, areasConhecimento) {
      state.areasConhecimento = areasConhecimento;
    },
    setFormacaoContinuadas(state, formacaoContinuada) {
      state.formacaoContinuada = formacaoContinuada;
    },
    setUserValidacao(state, userValidacao) {
      state.userValidacao = userValidacao;
    },
    setAreaFormacoes(state, areaformacoes) {
      state.areaformacoes = areaformacoes;
    },
    setServSelecionado(state, servSelecionado) {
      state.servSelecionado = servSelecionado;
    },
    setVersaoApi(state, versaoApi) {
      state.versaoApi = versaoApi;
    },
    setCicloSelecionado(state, cicloSelecionado) {
      state.cicloSelecionado = cicloSelecionado;
    },
    setQuestionarioSelecionado(state, questionarioSelecionado) {
      state.questionarioSelecionado = questionarioSelecionado;
    },
    setPerguntasQuestionario(state, perguntasQuestionario) {
      state.perguntasQuestionario = perguntasQuestionario;
    },
    setTokenrecaptcha(state, tokenrecaptcha) {
      state.tokenrecaptcha = tokenrecaptcha;
    },
    incCounterLoader(state) {
      state.counterLoader++;
    },
    decCounterLoader(state) {
      state.counterLoader--;
    },
    setIsRefreshMenu(state, flagisRefreshMenu) {
      state.isRefreshMenu = flagisRefreshMenu;
    },
  },
  actions: {
    logarUsuario(context, payload) {
      context.commit("setLoader", true);
      let formData = new FormData();
      formData.append("client", process.env.VUE_APP_USERNAME_API);
      formData.append("username", payload.login);
      formData.append("password", payload.senha);
      formData.append("grant_type", "password");

      delete payload.vue.$http.defaults.headers.common["Content-Type"];

      payload.vue.$http.defaults.headers.common[
        "Authorization"
      ] = `Basic ${btoa(
        process.env.VUE_APP_USERNAME_API +
          ":" +
          process.env.VUE_APP_PASSWORD_API
      )}`;

      payload.vue.$http
        .post(`${baseApiUrl}/oauth/token`, formData, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
          },
        })
        .then((res) => {
          payload.vue.$toast.removeAllGroups();

          let LocalStorageSeplag = localStorage.getItem(
            process.env.VUE_APP_USER_KEY
          );

          let storageSeplagJson = null;

          if (LocalStorageSeplag) {
            storageSeplagJson = JSON.parse(atob(LocalStorageSeplag));
          } else {
            storageSeplagJson = {
              token: "",
              [process.env.VUE_APP_NOME_SISTEMA]: {},
            };
          }

          storageSeplagJson.token = res.data;

          /**
           * storageSeplagJson : {
           *  token: string,
           *  VUE_APP_NOME_SISTEMA:{
           *    login: string
           *    versaoFront: string
           *  }
           * }
           */

          storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA] = {
            login: payload.login,
            versaoFront: process.env.VUE_APP_VERSAO,
          };

          // var userlogado = {
          //   token: JSON.stringify(res.data),
          //   login: payload.login,
          // };
          //
          // localStorage.setItem(
          //   process.env.VUE_APP_USER_KEY,
          //   btoa(JSON.stringify(userlogado))
          // );

          localStorage.setItem(
            process.env.VUE_APP_USER_KEY,
            btoa(JSON.stringify(storageSeplagJson))
          );

          context.commit("setToken", JSON.stringify(storageSeplagJson.token));
          context.commit("setUserLogado", true);
          context.dispatch("buscarUsuario", payload.vue);
          context.commit("setLoader", false);

          return true;
        })
        .catch((error) => {
          context.commit("setLoader", false);

          if (
            error.response &&
            error.response.data.error_description == "Bad credentials"
          ) {
            printToast({
              severity: "error",
              summary: "Usuario ou Senha invalida!!",
            });
          } else {
            if (
              error.response &&
              error.response.data &&
              error.response.data.error_description
            ) {
              printToast({
                severity: "error",
                summary: error.response.data.error_description,
              });
            } else {
              printToast({
                severity: "error",
                summary: "Ocorreu um erro na execução dessa operação",
              });
            }
          }
        });
    },
    async buscarUsuario(context, vue) {
      // var dataToken = JSON.parse(atob(localStorage.getItem(process.env.VUE_APP_USER_KEY)))
      // let res = await vue.$http.get(`${baseApiUrl}/seguranca/contasacesso/user/${dataToken.login}.`)

      // if(res.status==200){
      //      context.commit("setUser",JSON.stringify(res.data))
      //  }
      //  return true;
      let LocalStorageSeplag = localStorage.getItem(
        process.env.VUE_APP_USER_KEY
      );
      let dadosStorageSeplagJson = null;

      if (LocalStorageSeplag) {
        dadosStorageSeplagJson = decodeURI(atob(LocalStorageSeplag));
      }

      let storageSeplagJson = JSON.parse(dadosStorageSeplagJson);

      if (
        storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA] &&
        storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA].seguranca
      ) {
        context.commit(
          "setUser",
          storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA].seguranca
        );
      } else {
        vue.$http
          .get(`${baseApiUrl}/seguranca/contasacesso/me`)
          .then((res) => {
            storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA] = {
              ...storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA],
              seguranca: res.data,
            };

            let dadosStorageSeplagJson = encodeURI(
              JSON.stringify(storageSeplagJson)
            );

            localStorage.setItem(
              process.env.VUE_APP_USER_KEY,
              btoa(dadosStorageSeplagJson)
            );
            context.commit("setUser", res.data);
            context.commit("setIsRefreshMenu", true);
            let v_cAcesso = res.data.contaAcesso;
            if (v_cAcesso.pessoa && v_cAcesso.pessoa != null) {
              let v_pessoa = v_cAcesso.pessoa;
              if (v_pessoa.servidor && v_pessoa.servidor != null) {
                let v_matricula = v_pessoa.servidor.numrMatricula;
                vue.$http.get(
                  `${baseApiUrl}/seap/situacaofuncional/ajustarSituacaoFuncionalSeap/${v_matricula}`
                );
              }
            }
          })
          .catch(() => {
            context.dispatch("logoutUsuario");
          });
      }

      // if (res.status == 200) {
      //   context.commit('setUser', JSON.stringify(res.data));
      //   return true;
      // }

      // return false;
    },

    async buscarCicloPessoa(context, vue) {
      let res = await vue.$http.get(
        `${baseApiUrl}/ciclopessoas/resumo/${context.getters.getIdenPessoa}`
      );
      if (res.status == 200) {
        context.commit("setCicloPessoa", JSON.stringify(res.data));
      }
      return true;
    },

    logoutUsuario(context) {
      localStorage.removeItem(process.env.VUE_APP_USER_KEY);
      context.commit("setUserLogado", false);
      context.commit("setToken", null);
      context.commit("setUser", null);
      context.commit("setCicloPessoa", null);
      context.commit("setIdenPessoa", null);
    },

    async atualizarSituacaoFuncional(context, vue) {
      let user = context.getters.getUser;
      if (user.contaAcesso.pessoa.servidor != null) {
        vue.$http.get(
          `${baseApiUrl}/seap/situacaofuncional/ajustarSituacaoFuncionalSeap/${user.contaAcesso.pessoa.servidor.numrMatricula}`
        );
      }
      /*
          Checar Situação Funcional do Usuário no Seap
      */
      /*if(res.data.pessoa.servidor!=null){
      vue.$http.get(`${baseApiUrl}/seap/situacaofuncional/ajustarSituacaoFuncionalSeap/${res.data.pessoa.servidor.numrMatricula}`)
      }*/
    },

    async refreshToken(context, vue) {
      var formData = new URLSearchParams();
      formData.append("grant_type", "refresh_token");

      delete vue.$http.defaults.headers.common["Content-Type"];

      vue.$http.defaults.headers.common["Authorization"] = `Basic ${btoa(
        process.env.VUE_APP_USERNAME_API +
          ":" +
          process.env.VUE_APP_PASSWORD_API
      )}`;

      let res = await vue.$http
        .post(`${baseApiUrl}/oauth/token`, formData, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
          },
        })
        .catch(() => {
          vue.$toast.add({
            severity: "error",
            summary: "Sua sessão expirou! Por favor faça login novamente",
            life: 3000,
          });
          context.dispatch("logoutUsuario");
        });

      if (res && res.status == 200) {
        let token = JSON.parse(
          decodeURI(atob(localStorage.getItem(process.env.VUE_APP_USER_KEY)))
        );
        token.token = JSON.stringify(res.data);
        localStorage.setItem(
          process.env.VUE_APP_USER_KEY,
          btoa(JSON.stringify(token))
        );

        context.commit("setToken", JSON.stringify(res.data));
        context.commit("setUserLogado", true);
        return true;
      }
    },
    async verificaToken(context, vue) {
      let jwt = new VueEasyJwt();
      if (jwt.isExpired(context.getters.getToken.access_token)) {
        await context.dispatch("refreshToken", vue);
      }
    },
  },
});
